export default "__VITE_ASSET__CUpt7Bp4__"